import React from 'react';
import styled from 'styled-components';

const Navbar = styled.nav`
  background-color: rgba(12, 13, 22, 0.6);
`;
const logoHeight = 40;
const Logo = styled.img`
  height: ${logoHeight}px !important;
  max-height: ${logoHeight}px !important;
`;

const Link = styled.a`
  height: auto;
  color: #e2cdcc !important;
  background-color: rgba(84, 86, 162, 0.8);
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
  font-size: 16px;

  &:hover {
    background-color: rgba(84, 86, 162, 1);
  }
`;

const Title = styled.h2`
  color: #686eb2;
  font-weight: bold;
`;

const Subtitle = styled.p`
  color: #e2cdcc;
`;

const NavInfo = styled.div`
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.4em;
`;

export default function Nav() {
  return (
    <Navbar
      className="navbar is-fixed-top px-3 py-1"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container is-fluid">
        <NavInfo className="navbar-item is-hidden-mobile is-marginless">
          <Title className="is-size-5">Chatbot Halloween Experience</Title>
          <Subtitle className="is-size-6">Powered by Landbot</Subtitle>
        </NavInfo>
        <div className="navbar-menu">
          <div className="navbar-end">
            <div className="buttons">
              <Link
                className="button is-link px-2 py-1 is-size-7-mobile"
                href="https://landbot.io/blog/landbot-halloween-chatbot-campaign/"
                target="_blank"
              >
                Behind the scenes
              </Link>
              <Link
                className="button is-link px-2 py-1 is-size-7-mobile"
                href="https://app.landbot.io/signup/?utm_campaign=halloween_2020"
                target="_blank"
              >
                Sign up with Landbot
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Navbar>
  );
}
